module.exports = __webpack_public_path__ + "static/fonts/notokr-light.2ea9b0e.woff";


//////////////////
// WEBPACK FOOTER
// ./src/views/nutrilite/a7070-glister/font/notokr-light.woff
// module id = 0+v7
// module chunks = 0